/**
 * Detail-page price slot — Rust domain SSOT.
 *
 * WHICH price the detail page binds (rent vs sale) is `detailPriceSlot` from
 * the `domain-core` wasm rail — the same snap machine iOS, Android, and the
 * backend consume, so the slot decision can never drift per platform. The
 * rule snaps the browsed intent onto the OFFERED flags and is STRICT: it
 * never substitutes the other mode's price, and `undefined` means "hide the
 * price row" (nothing offered — an upstream data bug). This file only
 * bridges the app's lowercase intent slug (`IntentTypeValue`) onto the proto
 * wire number the SSOT takes; it lives in the lib layer so the component
 * layer never imports proto (Rule #1).
 */
import { urlValueToIntentType, type IntentTypeValue } from '@letsgethome/lib/types/listings';
import { detailPriceSlot, type DetailPriceSlot } from '@letsgethome/lib/wasm';

/**
 * Resolve the SSOT slot decision for a stringified intent.
 * `undefined` = the listing offers nothing the intent can snap to — hide.
 */
export function detailPriceSlotForIntent(
  intent: IntentTypeValue,
  rentOffered: boolean,
  saleOffered: boolean
): DetailPriceSlot | undefined {
  return detailPriceSlot(urlValueToIntentType(intent), rentOffered, saleOffered);
}
